export const translations = {
  hu: {
    nav: {
      home: "Kezdőlap",
      menu: "Étlap",
      gallery: "Galéria",
      contact: "Kapcsolat",
    },
    brandAria: "Mizu kezdőlap",
    logoAlt: "Mizu logó",
    hero: {
      brandSub: "Brunch & Coffee",
      tagline: "A nap legjobb része itt kezdődik.",
      features: ["Minőségi kávé", "Egész napos brunch", "Nyugodt környezet"],
      viewMenu: "Étlap megtekintése",
    },
    about: {
      label: "— A Mizuról",
      title: "Egy otthonos hely,",
      titleEm: "neked.",
      text: "A Mizunál hiszünk abban, hogy a brunch több, mint egy étkezés — egy pillanat, amikor lelassulhatsz és élvezheted az életet. Gondosan készített ételeket és specialty kávét kínálunk meleg, barátságos környezetben.",
      btn: "Tudj meg többet →",
      imageAlt: "A Mizu belső tere",
    },
    menu: {
      eyebrow: "Brunch & Coffee",
      titleFood: "Étlap",
      titleDrink: "Itallap",
      featuredLabel: "Ajánlott kedvenceink",
      moreItems: "Teljes kategória",
      lessItems: "Kevesebb megjelenítése",
      typeLabel: "Ételek vagy italok",
      tabsLabel: "Kategóriák",
      openDetails: "Részletek",
      closeDetails: "Bezárás",
      ingredients: "Összetevők",
      allergens: "Allergének",
      category: "Kategória",
      price: "Ár",
      vatNote: "Az árak forintban értendők és tartalmazzák az ÁFÁ-t.",
      pdf: {
        btn: "PDF",
        btnLabel: "PDF étlap vagy itallap",
        optionFood: "Étlap",
        optionDrink: "Itallap",
        foods: "Ételek",
        drinks: "Italok",
        openHint: "(új lapon nyílik)",
      },
      lunch: {
        eyebrow: "Hétköznapi ebéd",
        title: "Heti ebédajánlat",
        days: "Hétfő – Péntek",
        hours: "11:00 – 15:00",
        stampNote: "Minden héten új menü",
        courses: ["Leves", "Főétel", "Menü"],
        text: "Minden héten új levesek és főételek, külön vagy menüben. Hogy mi kerül a tányérra, azt az Instagramon és a Facebookon mutatjuk meg.",
        instagram: "Heti menü az Instagramon",
        facebook: "Facebook",
      },
    },
    coffee: {
      eyebrow: "Saját kávé",
      title: "Mizu Coffee",
      paragraphs: [
        "A Mizu Coffee világos pörkölésű, 100% arabica — a ház saját kávéja, gondosan válogatott specialty szemekből.",
        "Gazdag aroma, kiegyensúlyozott íz és friss karakter: egész nap vár a Mizu pultjánál, frissen őrölve, szeretettel elkészítve.",
      ],
      accent: "Világos pörkölés · 100% arabica · 1 kg",
      cta: "Vásárlás",
      size: "1 kg",
      imageAlt: "Mizu Coffee — világos pörkölésű, 100% arabica",
      placeholderLabel: "Kép hamarosan",
    },
    shop: {
      nav: "Webshop",
      cartLabel: "Kosár",
      cartCount: (n) => `Kosár, ${n} termék`,
      eyebrow: "Mizu Brunch & Coffee",
      title: "Webshop",
      subtitle: "Vidd haza a Mizu ízeit: saját pörkölésű kávé, házi finomságok és apró ajándékok.",
      categories: {
        all: "Összes",
        coffee: "Kávé",
        homemade: "Házi finomságok",
        merch: "Ajándék & merch",
        other: "Egyéb",
      },
      addToCart: "Kosárba",
      added: "Kosárban",
      soldOut: "Elfogyott",
      details: "Részletek",
      close: "Bezárás",
      quantity: "Mennyiség",
      decrease: "Kevesebb",
      increase: "Több",
      loading: "Termékek betöltése…",
      empty: "Hamarosan érkeznek a termékek.",
      loadError: "Nem sikerült betölteni a termékeket. Frissítsd az oldalt.",
      cartTitle: "Kosár",
      cartEmpty: "A kosarad még üres.",
      continueShopping: "Vásárlás folytatása",
      subtotal: "Részösszeg",
      shippingNote: "Az átvétel módját és a szállítási díjat a következő lépésben választod ki.",
      checkout: "Tovább a pénztárhoz",
      remove: "Eltávolítás",
      unavailable: "Már nem elérhető – távolítsd el a kosárból.",
      backToShop: "Vissza a webshopba",
      productUnavailable: "Valamelyik termék közben elfogyott. Nézd át a kosarad.",
      itemsLabel: (n) => `${n} termék`,
      soon: {
        eyebrow: "Mizu webshop",
        title: "Hamarosan",
        text: "Pörkölünk, kavarunk, csomagolunk. Hamarosan megnyitjuk a webshopot, és folyamatosan bővülő kínálattal hazaviheted a Mizu kedvenceit.",
        availableBadge: "Már most kapható",
        availableTitle: "Mizu Coffee",
        availableMeta: "Saját pörkölésű, 100% arabica · 1 kg",
        availableCta: "Megrendelem",
        bagSticker: "Már kapható!",
        ringText: "ÚJ TERMÉKEK HAMAROSAN • MIZU WEBSHOP • ",
      },
    },
    checkout: {
      productTitle: "Mizu Brunch & Coffee",
      orderTitle: "Rendelés",
      howToReceive: "Hogyan kéred?",
      stepShipping: "Szállítás",
      stepDetails: "Adatok",
      stepPayment: "Fizetés",
      shippingTitle: "Szállítás módja",
      locationTitle: "Átvételi pont / cím",
      contactTitle: "Elérhetőség",
      contactHeading: "Add meg az adataidat",
      contactSectionTitle: "Kapcsolattartási adatok",
      contactPrivacy: "Az adataidat kizárólag a rendelés teljesítéséhez használjuk.",
      requiredFields: "* Kötelező mező",
      paymentTitle: "Fizetés",
      continue: "Tovább",
      continueToDetails: "Tovább az adatokhoz ›",
      continueToPayment: "Tovább a fizetéshez →",
      back: "Vissza",
      backToHome: "Vissza a főoldalra",
      backToShipping: "Vissza a szállításhoz",
      close: "Bezárás",
      loading: "Betöltés…",
      error: "A fizetés nem indítható. Próbáld újra később.",
      success: "Köszönjük a rendelést! Hamarosan felvesszük veled a kapcsolatot.",
      stripeMissing: "A fizetés jelenleg nem elérhető.",
      freeShipping: "Ingyenes",
      shippingLabel: "szállítás",
      size: "1 kg",
      summaryTitle: "Rendelésed",
      productLabel: "Termék",
      subtotalLabel: "Részösszeg",
      shippingSummaryLabel: "Szállítás",
      totalLabel: "Összesen",
      securePayment: "Biztonságos fizetés",
      groupPickup: "Átvétel",
      groupLocker: "Csomagpont",
      groupHome: "Házhozszállítás",
      deliveryDetails: "Kiszállítás",
      contactSummary: "Kapcsolat",
      pickupAddress: "Fáy utca 75, Budapest, 1135 — személyes átvétel",
      pickupHint: "Válassz csomagpontot a térképen, majd kattints a „Kiválasztom” gombra.",
      foxpostMapTitle: "Foxpost csomagpont kereső",
      mapLoadError: "A térkép betöltése sikertelen.",
      mapLoading: "Térkép betöltése…",
      addressHeading: "Add meg a címeidet",
      addressSectionTitle: "Szállítási cím",
      billingSectionTitle: "Számlázási cím",
      shippingSameAsBilling: "A szállítási cím megegyezik a számlázási címmel",
      addressHint: "Add meg a számlázási címedet, és jelöld, ha a szállítás is oda megy.",
      contactHint:
        "A rendelés visszaigazolását és az átvételi értesítést ezekre az elérhetőségekre küldjük.",
      postalCode: "Irányítószám",
      city: "Város",
      street: "Utca",
      houseNumber: "Házszám",
      postalCodePlaceholder: "1135",
      cityPlaceholder: "Budapest",
      streetPlaceholder: "Fáy utca",
      houseNumberPlaceholder: "75",
      nameLabel: "Teljes név",
      emailLabel: "E-mail-cím",
      phoneLabel: "Telefonszám",
      namePlaceholder: "Kovács Anna",
      emailPlaceholder: "anna@email.hu",
      phonePlaceholder: "30 123 4567",
      validationShipping: "Válassz szállítási módot.",
      validationPickup: "Válassz csomagpontot a térképen.",
      validationAddress: "Töltsd ki a szállítási címet.",
      validationBillingAddress: "Töltsd ki a számlázási címet.",
      validationContact: "Add meg a neved és telefonszámod.",
      validationEmail: "Adj meg érvényes e-mail címet.",
      paymentHint: "Add meg a bankkártya adataidat.",
      payButton: "Fizetés: {amount}",
      paymentError: "A fizetés sikertelen. Próbáld újra.",
      confirmTitle: "Rendelés állapota",
      confirmCheckingEyebrow: "Ellenőrzés",
      confirmCheckingTitle: "Fizetés ellenőrzése…",
      confirmProcessingEyebrow: "Folyamatban",
      confirmProcessingTitle: "A fizetés feldolgozás alatt van",
      confirmProcessingCopy:
        "Amint megérkezik a megerősítés, e-mailben értesítünk. Nyugodtan visszatérhetsz a főoldalra.",
      confirmSuccessEyebrow: "Sikeres rendelés",
      confirmSuccessTitle: "Köszönjük a rendelést!",
      confirmSuccessCopy:
        "A fizetés sikeres volt. Hamarosan e-mailben küldjük a visszaigazolást és a további részleteket.",
      confirmErrorEyebrow: "Sikertelen fizetés",
      confirmErrorTitle: "Nem sikerült a fizetés",
      confirmMissingPayment: "Nem található fizetési adat. Próbáld újra a rendelést.",
      confirmBackHome: "Vissza a főoldalra",
      confirmRetry: "Újrapróbálás",
      methods: {
        pickup: "Személyes átvétel",
        foxpostLocker: "Foxpost csomagpont",
        glsLocker: "GLS csomagpont",
        foxpostHome: "Foxpost házhozszállítás",
        glsHome: "GLS házhozszállítás",
      },
    },
    gallery: {
      title: "Galéria",
      closeLabel: "Bezárás",
      videoLabel: "Videó lejátszása",
      alt: {
        icedDrinks: "Jeges latte és matcha latte fatálcán a Mizuban",
        coffeeVideo: "Kávéfőzés a Mizu eszpresszógépén",
        showcase: "A Mizu vitrinje: cruffin, croissant, házi krémek és saját pörkölésű kávé",
        kitchenVideo: "Tálalás a Mizu konyhájában: lazacos bowl és brunch tányérok",
        cocktails: "Spritzek és espresso martini a Mizuban",
      },
    },
    testimonials: {
      title: "Vendégeink mondták",
      googleBadge: "Google-értékelés",
      prev: "Előző vélemény",
      next: "Következő vélemény",
      items: {
        petra: {
          name: "PETRA",
          text: "Szuper kávé és gofri! Nagyon finom volt. 😋 Jó hangulatos zene.",
        },
        lotti: {
          name: "LOTTI",
          text: "Szuper volt minden, jól megtalálták a piaci rést a környéken. 😊",
        },
        matyas: {
          name: "MÁTYÁS",
          text: "Kellemes reggeliző & brunch hely, finom kávé, kedves kiszolgálás. Az ételek nagyon jól néznek ki. Van gofri, tapas tál, eggs benedict, egészséges joghurttál – minden, ami egy tartalmas reggelihez kell. Ha a környéken laksz, mindenképp nézzetek el ide, ajánlom.",
        },
        daffodils: {
          name: "VENDÉG",
          text: "Ma itt ebédeltem, egy menüt ettem. Nagyon finom volt minden, éttermi színvonal! A kiszolgálás gyors volt és kedves. :) Még biztos visszajövök.",
        },
        peter: {
          name: "PÉTER",
          text: "Nagyon kellemes, belvárosi pörgős kávézó hangulat, gyors kiszolgálás, kényelmes ülőhelyek. Gyermek- és kutyabarát hely, jönni fogunk még, az biztos!",
        },
        es8: {
          name: "VENDÉG",
          text: "Finom kávét és süteményeket fogyasztottunk szuper hangulatban. A felszolgálás barátságos és gyors volt.",
        },
        lajos: {
          name: "LAJOS",
          text: "Finom a kávé, kellemes hangulatos kis reggeliző. Rendes, kulturált kiszolgálás.",
        },
        hanna: {
          name: "HANNA",
          text: "Nagyon kellemes élményben volt részem! Eggs Benedictet ettem, ami tökéletesen volt elkészítve, nagyon finom és friss volt. A kiszolgálás kedves, a hangulat is kellemes. Külön plusz pont a frissen facsart narancsléért. Biztosan visszatérek, csak ajánlani tudom!",
        },
        bence: {
          name: "BENCE",
          text: "Nagyon finom kávé, fiatalos hangulat, barátságos kiszolgálás. Az ételeket is kipróbálom legközelebb.",
        },
        lucky: {
          name: "LUCKY",
          text: "Napi menüt ettünk mindketten a feleségemmel. Kifejezetten finom volt. Kiemelném a fűszerezést és az állagot. Tökéletes volt.",
        },
      },
    },
    visitUs: {
      title: "Látogass meg minket!",
      address: "Fáy utca 75, Budapest, 1135",
      hours: "Hétfőtől vasárnapig: 7:00 – 17:30",
      bookTable: "Asztalfoglalás",
      writeUs: "Írj nekünk",
      emailCopied: "Email kimásolva",
      mapTitle: "MIZU Brunch & Coffee a Google Térképen — Fáy utca 75, Budapest",
      mapOpen: "Megnyitás a Google Térképen",
      phoneValue: "+36 70 730 9102",
      emailValue: "info@mizubrunch.hu",
      instagram: "@mizubudapest",
      instagramUrl: "https://www.instagram.com/mizubudapest/",
      facebook: "/mizubrunch",
      facebookUrl: "https://www.facebook.com/mizubrunch",
      closing: "Találkozunk a MIZU-ban!",
      footerBrand: "MIZU Brunch & Coffee",
      footerRights: "Minden jog fenntartva.",
    },
    newsletter: {
      eyebrow: "Hírlevél",
      title: "Iratkozz fel",
      subtitle:
        "Értesülj elsőként ajánlatainkról, híreinkről és meglepetéseinkről.",
      emailLabel: "E-mail cím",
      emailPlaceholder: "E-mail cím",
      submit: "Feliratkozom",
      success: "Köszönjük, hogy feliratkoztál!",
      error: "Nem sikerült feliratkozni. Próbáld újra később.",
      requiredMessage: "Kérjük, töltsd ki ezt a mezőt.",
      invalidEmailMessage: "Kérjük, adj meg egy érvényes e-mail címet.",
    },
    booking: {
      title: "Asztalfoglalás",
      subtitle:
        "Foglalj asztalt nálunk! Kollégánk hamarosan ellenőrzi, és e-mailben visszaigazoljuk.",
      nameLabel: "Név",
      emailLabel: "E-mail cím",
      phoneLabel: "Telefonszám",
      dateLabel: "Dátum",
      timeLabel: "Időpont",
      pickDateFirst: "Előbb válassz dátumot.",
      noSlotsLeft: "Erre a napra már nincs szabad időpont. Válassz másik napot.",
      timeRequired: "Kérjük, válassz időpontot.",
      guestsDecrease: "Kevesebb fő",
      guestsIncrease: "Több fő",
      guestsLabel: "Létszám",
      guestsValue: (n) => `${n} fő`,
      noteLabel: "Megjegyzés (nem kötelező)",
      largeGroupHint: "12 főnél nagyobb társaság esetén kérjük, hívj minket.",
      submit: "Foglalás küldése",
      successTitle: "Köszönjük a foglalásod!",
      successText:
        "Kollégánk hamarosan ellenőrzi, és e-mailben visszaigazoljuk a foglalásodat.",
      error: "Nem sikerült elküldeni a foglalást. Próbáld újra, vagy hívj minket.",
      errorTooMany: "Túl sok foglalási kérés érkezett. Próbáld újra később, vagy hívj minket.",
      errorTime: "Ez az időpont már nem foglalható. Kérjük, válassz másikat.",
      closeLabel: "Bezárás",
    },
    langLabel: "Nyelv",
  },
  en: {
    nav: {
      home: "Home",
      menu: "Menu",
      gallery: "Gallery",
      contact: "Contact",
    },
    brandAria: "Mizu home",
    logoAlt: "Mizu logo",
    hero: {
      brandSub: "Brunch & Coffee",
      tagline: "The best part of the day starts here.",
      features: ["Quality coffee", "All-day brunch", "Calm setting"],
      viewMenu: "View Menu",
    },
    about: {
      label: "— About Mizu",
      title: "A cozy place made for",
      titleEm: "you.",
      text: "At Mizu, we believe brunch is more than a meal — it's a moment to slow down and enjoy life. We serve carefully crafted dishes and specialty coffee in a warm and welcoming space.",
      btn: "Learn More →",
      imageAlt: "Mizu cafe interior",
    },
    menu: {
      eyebrow: "Brunch & Coffee",
      titleFood: "Food menu",
      titleDrink: "Drinks menu",
      featuredLabel: "Our recommended favorites",
      moreItems: "Full category",
      lessItems: "Show less",
      typeLabel: "Food or drinks",
      tabsLabel: "Categories",
      openDetails: "Details",
      closeDetails: "Close",
      ingredients: "Ingredients",
      allergens: "Allergens",
      category: "Category",
      price: "Price",
      vatNote: "Prices are in HUF and include VAT.",
      pdf: {
        btn: "PDF",
        btnLabel: "Food or drinks PDF menu",
        optionFood: "Food menu",
        optionDrink: "Drinks menu",
        foods: "Food",
        drinks: "Drinks",
        openHint: "(opens in a new tab)",
      },
      lunch: {
        eyebrow: "Weekday lunch",
        title: "Weekly lunch offer",
        days: "Monday – Friday",
        hours: "11:00 – 15:00",
        stampNote: "A new menu every week",
        courses: ["Soup", "Main", "Set menu"],
        text: "New soups and mains every week, on their own or as a set menu. See what's on the plate this week on Instagram and Facebook.",
        instagram: "This week's menu on Instagram",
        facebook: "Facebook",
      },
    },
    coffee: {
      eyebrow: "Our coffee",
      title: "Mizu Coffee",
      paragraphs: [
        "Mizu Coffee is a light-roast, 100% Arabica house coffee — carefully selected specialty beans.",
        "Rich aroma, balanced flavour and a fresh character: available all day at the Mizu counter, freshly ground and made with care.",
      ],
      accent: "Light roast · 100% Arabica · 1 kg",
      cta: "Buy now",
      size: "1 kg",
      imageAlt: "Mizu Coffee — light roast, 100% Arabica",
      placeholderLabel: "Image coming soon",
    },
    shop: {
      nav: "Shop",
      cartLabel: "Cart",
      cartCount: (n) => `Cart, ${n} items`,
      eyebrow: "Mizu Brunch & Coffee",
      title: "Shop",
      subtitle: "Take a little Mizu home: our own roasted coffee, homemade treats and small gifts.",
      categories: {
        all: "All",
        coffee: "Coffee",
        homemade: "Homemade treats",
        merch: "Gifts & merch",
        other: "Other",
      },
      addToCart: "Add to cart",
      added: "In cart",
      soldOut: "Sold out",
      details: "Details",
      close: "Close",
      quantity: "Quantity",
      decrease: "Decrease",
      increase: "Increase",
      loading: "Loading products…",
      empty: "Products are coming soon.",
      loadError: "We couldn't load the products. Please refresh the page.",
      cartTitle: "Cart",
      cartEmpty: "Your cart is empty.",
      continueShopping: "Continue shopping",
      subtotal: "Subtotal",
      shippingNote: "You'll choose pickup or delivery and see the shipping fee in the next step.",
      checkout: "Go to checkout",
      remove: "Remove",
      unavailable: "No longer available – please remove it from your cart.",
      backToShop: "Back to the shop",
      productUnavailable: "An item in your cart just sold out. Please review your cart.",
      itemsLabel: (n) => `${n} items`,
      soon: {
        eyebrow: "Mizu shop",
        title: "Coming soon",
        text: "We're roasting, stirring and packing. The shop opens soon with a growing range of Mizu favourites to take home.",
        availableBadge: "Available now",
        availableTitle: "Mizu Coffee",
        availableMeta: "Our own roast, 100% arabica · 1 kg",
        availableCta: "Order now",
        bagSticker: "Available now!",
        ringText: "NEW PRODUCTS COMING SOON • MIZU SHOP • ",
      },
    },
    checkout: {
      productTitle: "Mizu Brunch & Coffee",
      orderTitle: "Order",
      howToReceive: "How would you like it?",
      stepShipping: "Shipping",
      stepDetails: "Details",
      stepPayment: "Payment",
      shippingTitle: "Shipping method",
      locationTitle: "Pickup point / address",
      contactTitle: "Contact details",
      contactHeading: "Enter your details",
      contactSectionTitle: "Contact information",
      contactPrivacy: "We only use your details to fulfill your order.",
      requiredFields: "* Required field",
      paymentTitle: "Payment",
      continue: "Continue",
      continueToDetails: "Continue to details ›",
      continueToPayment: "Continue to payment →",
      back: "Back",
      backToHome: "Back to home",
      backToShipping: "Back to shipping",
      close: "Close",
      loading: "Loading…",
      error: "Checkout could not be started. Please try again later.",
      success: "Thank you for your order! We will contact you shortly.",
      stripeMissing: "Checkout is currently unavailable.",
      freeShipping: "Free",
      shippingLabel: "shipping",
      size: "1 kg",
      summaryTitle: "Your order",
      productLabel: "Product",
      subtotalLabel: "Subtotal",
      shippingSummaryLabel: "Shipping",
      totalLabel: "Total",
      securePayment: "Secure payment",
      groupPickup: "Pickup",
      groupLocker: "Parcel point",
      groupHome: "Home delivery",
      deliveryDetails: "Delivery",
      contactSummary: "Contact",
      pickupAddress: "Fáy utca 75, Budapest, 1135 — pickup in store",
      pickupHint: "Select a parcel point on the map, then click “Select”.",
      foxpostMapTitle: "Foxpost parcel point finder",
      mapLoadError: "Could not load the map.",
      mapLoading: "Loading map…",
      addressHeading: "Enter your addresses",
      addressSectionTitle: "Shipping address",
      billingSectionTitle: "Billing address",
      shippingSameAsBilling: "Shipping address is the same as billing address",
      addressHint: "Enter your billing address, and mark if delivery goes there too.",
      contactHint:
        "We’ll send your order confirmation and pickup updates to these contacts.",
      postalCode: "Postal code",
      city: "City",
      street: "Street",
      houseNumber: "House no.",
      postalCodePlaceholder: "1135",
      cityPlaceholder: "Budapest",
      streetPlaceholder: "Fay utca",
      houseNumberPlaceholder: "75",
      nameLabel: "Full name",
      emailLabel: "Email address",
      phoneLabel: "Phone number",
      namePlaceholder: "Anna Kovacs",
      emailPlaceholder: "anna@email.com",
      phonePlaceholder: "30 123 4567",
      validationShipping: "Please choose a shipping method.",
      validationPickup: "Please select a parcel point on the map.",
      validationAddress: "Please complete the delivery address.",
      validationBillingAddress: "Please complete the billing address.",
      validationContact: "Please enter your name and phone number.",
      validationEmail: "Please enter a valid email address.",
      paymentHint: "Enter your card details.",
      payButton: "Pay: {amount}",
      paymentError: "Payment failed. Please try again.",
      confirmTitle: "Order status",
      confirmCheckingEyebrow: "Checking",
      confirmCheckingTitle: "Confirming your payment…",
      confirmProcessingEyebrow: "Processing",
      confirmProcessingTitle: "Your payment is still processing",
      confirmProcessingCopy:
        "We’ll email you as soon as it’s confirmed. You can return to the home page.",
      confirmSuccessEyebrow: "Order confirmed",
      confirmSuccessTitle: "Thank you for your order!",
      confirmSuccessCopy:
        "Payment succeeded. We’ll email your confirmation and next steps shortly.",
      confirmErrorEyebrow: "Payment failed",
      confirmErrorTitle: "We couldn’t complete the payment",
      confirmMissingPayment: "No payment details found. Please try checkout again.",
      confirmBackHome: "Back to home",
      confirmRetry: "Try again",
      methods: {
        pickup: "Pickup in store",
        foxpostLocker: "Foxpost parcel locker",
        glsLocker: "GLS parcel point",
        foxpostHome: "Foxpost home delivery",
        glsHome: "GLS home delivery",
      },
    },
    gallery: {
      title: "Gallery",
      closeLabel: "Close",
      videoLabel: "Play video",
      alt: {
        icedDrinks: "Iced latte and matcha latte on a wooden tray at Mizu",
        coffeeVideo: "Coffee being made on the Mizu espresso machine",
        showcase: "The Mizu showcase: cruffins, croissants, homemade spreads and our own roasted coffee",
        kitchenVideo: "Plating in the Mizu kitchen: salmon bowls and brunch plates",
        cocktails: "Spritzes and an espresso martini at Mizu",
      },
    },
    testimonials: {
      title: "What our guests say",
      googleBadge: "Google review",
      prev: "Previous review",
      next: "Next review",
      items: {
        petra: {
          name: "PETRA",
          text: "Great coffee and waffles! Really delicious. 😋 Nice, cosy music too.",
        },
        lotti: {
          name: "LOTTI",
          text: "Everything was great – they really found a gap in the neighbourhood. 😊",
        },
        matyas: {
          name: "MÁTYÁS",
          text: "A pleasant breakfast & brunch place with good coffee and kind service. The food looks great: waffles, tapas plates, eggs benedict, a healthy yoghurt bowl – everything you need for a proper breakfast. If you live nearby, definitely stop by. Recommended.",
        },
        daffodils: {
          name: "GUEST",
          text: "I had lunch here, the daily menu. Everything was delicious, restaurant quality! Service was quick and friendly. :) I'll definitely be back.",
        },
        peter: {
          name: "PÉTER",
          text: "A really pleasant, lively downtown café vibe, quick service and comfortable seats. Kid- and dog-friendly – we'll definitely be back!",
        },
        es8: {
          name: "GUEST",
          text: "We had delicious coffee and cakes in a great atmosphere. The service was friendly and quick.",
        },
        lajos: {
          name: "LAJOS",
          text: "Good coffee, a pleasant, cosy little breakfast place. Decent, polite service.",
        },
        hanna: {
          name: "HANNA",
          text: "A really lovely experience! I had the Eggs Benedict, perfectly made, very tasty and fresh. Kind service and a nice atmosphere. Extra points for the freshly squeezed orange juice. I'll definitely be back – highly recommended!",
        },
        bence: {
          name: "BENCE",
          text: "Very good coffee, a youthful vibe and friendly service. I'll try the food next time.",
        },
        lucky: {
          name: "LUCKY",
          text: "My wife and I both had the daily menu. It was really tasty – especially the seasoning and the texture. Perfect.",
        },
      },
    },
    visitUs: {
      title: "Visit us!",
      address: "Fáy utca 75, Budapest, 1135",
      hours: "Mon – Sun: 7:00 AM – 5:30 PM",
      bookTable: "Book a table",
      writeUs: "Write to us",
      emailCopied: "Email copied",
      mapTitle: "MIZU Brunch & Coffee on Google Maps — Fáy utca 75, Budapest",
      mapOpen: "Open in Google Maps",
      phoneValue: "+36 70 730 9102",
      emailValue: "info@mizubrunch.hu",
      instagram: "@mizubudapest",
      instagramUrl: "https://www.instagram.com/mizubudapest/",
      facebook: "/mizubrunch",
      facebookUrl: "https://www.facebook.com/mizubrunch",
      closing: "See you at MIZU!",
      footerBrand: "MIZU Brunch & Coffee",
      footerRights: "All rights reserved.",
    },
    newsletter: {
      eyebrow: "Newsletter",
      title: "Subscribe",
      subtitle:
        "Be first to hear about our offers, news, and subscriber surprises.",
      emailLabel: "Email address",
      emailPlaceholder: "Email address",
      submit: "Subscribe",
      success: "Thanks for subscribing!",
      error: "Could not subscribe. Please try again later.",
      requiredMessage: "Please fill out this field.",
      invalidEmailMessage: "Please enter a valid email address.",
    },
    booking: {
      title: "Book a table",
      subtitle:
        "Reserve a table with us! Our colleague will verify it as soon as possible and confirm by email.",
      nameLabel: "Name",
      emailLabel: "Email address",
      phoneLabel: "Phone number",
      dateLabel: "Date",
      timeLabel: "Time",
      pickDateFirst: "Choose a date first.",
      noSlotsLeft: "No times left for this day. Please choose another day.",
      timeRequired: "Please choose a time.",
      guestsDecrease: "Fewer guests",
      guestsIncrease: "More guests",
      guestsLabel: "Guests",
      guestsValue: (n) => `${n} ${n === 1 ? "person" : "people"}`,
      noteLabel: "Note (optional)",
      largeGroupHint: "For groups larger than 12, please call us.",
      submit: "Send booking",
      successTitle: "Thank you for your booking!",
      successText:
        "Our colleague will verify your booking as soon as possible, and we will confirm it by email.",
      error: "Could not send your booking. Please try again, or call us.",
      errorTooMany: "Too many booking requests. Please try again later, or call us.",
      errorTime: "This time can no longer be booked. Please choose another one.",
      closeLabel: "Close",
    },
    langLabel: "Language",
  },
};

export const navIds = ["home", "menu", "gallery", "contact"];

export const navHrefs = {
  home: "#home",
  menu: "#etlap",
  gallery: "#gallery",
  contact: "#contact",
};
